import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';

/**
 * @constant
 * @type {string}
 */
export const MIND_TOUCH_CONFIG_ENDPOINT_URL =
  '/common-ui/api/contextualHelp/configuration';
const MIND_TOUCH_CONFIG_KEY = 'contextualHelp-config';

const ContextualHelpService = {
  /**
   * Gets ContextualHelp mapping configuration
   * @async
   * @warning This function will return null in case of any error
   * @function getContextualHelpConfiguration
   * @return {Object} - Returns a ContextualHelpConfiguration object that includes the mappings
   */
  getContextualHelpConfiguration: async () => {
    try {
      let contextualHelpConfig = sessionStorage.getItem(MIND_TOUCH_CONFIG_KEY);

      if (!!contextualHelpConfig && contextualHelpConfig !== 'undefined') {
        // If we already have the ContextualHelp configuration then use it
        contextualHelpConfig = JSON.parse(contextualHelpConfig);
      } else {
        // If we don't have the ContextualHelp configuration then call to common-ui to get it
        contextualHelpConfig = await kfetch(MIND_TOUCH_CONFIG_ENDPOINT_URL);
        // Store the value in the session storage.
        if (!!contextualHelpConfig) {
          sessionStorage.setItem(
            MIND_TOUCH_CONFIG_KEY,
            JSON.stringify(contextualHelpConfig),
          );
        }
      }
      return contextualHelpConfig;
    } catch (err) {
      rollbar.error(err);
      return null;
    }
  },

  cleanContextualHelpConfig: () => {
    sessionStorage.removeItem(MIND_TOUCH_CONFIG_KEY);
  },
};

export default ContextualHelpService;
